import { COLOR, CORNERS } from 'vars/index'
import * as BundleCovers from './BundleCard/BundleCardCovers'

export const VOD_CARD_HOVER_SCALE = {
  HORIZONTAL_CARD: 1.027,
  VERTICAL_CARD: 1.034,
}

export const CARDS_ASPECT_RATIO = {
  VERTICAL_DEFAULT: 0.67,
  SQUARE: 1,
  HORIZONTAL_TV_SHOW_OUTER_CARD: 1.22 /*for 1920*/,
  HORIZONTAL_DEFAULT: 1.78,
  HORIZONTAL_TV_SHOW_INNER_CARD: 1.694,
  TV_SHOW_EPISODE_POSTER_DEFAULT: 1.49,
  HORIZONTAL_TRIA_DEFAULT: 1.48,
  VERTICAL_VOD_TOP_CONTENT: 1.132,
  HORIZONTAL_VOD_TOP_CONTENT: 2.302,
  HORIZONTAL_CHANNEL_TOP_CONTENT: 2.435,
}

export const EVENT_CARD_ASPECT_RATIO = {
  TOP_CONTENT_VERTICAL: '--event-aspect-ratio-top-content-vertical',
  TOP_CONTENT_HORIZONTAL: '--event-aspect-ratio-top-content-horizontal',
  VERTICAL_DEFAULT: '--event-aspect-ratio-vertical-default',
  HORIZONTAL_DEFAULT: '--event-aspect-ratio-horizontal-default',
} as const
export type EVENT_CARD_ASPECT_RATIO =
  (typeof EVENT_CARD_ASPECT_RATIO)[keyof typeof EVENT_CARD_ASPECT_RATIO]

export const CardCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_10: CORNERS.CORNERS_10,
  CORNERS_20: CORNERS.CORNERS_20,
  CORNERS_25: CORNERS.CORNERS_25,
  CORNERS_30: CORNERS.CORNERS_30,
  CORNERS_50: CORNERS.CORNERS_50,
  CORNERS_ROUND: CORNERS.CORNERS_ROUND,
} as const
export type CardCorners = (typeof CardCorners)[keyof typeof CardCorners]

export const CardAnimations = {
  ScaleUp: 'scale-up',
  ScaleUp110: 'scale-up-110',
  ShadowNormal: 'shadow-normal',
  ShadowHuge: 'shadow-huge',
  FadeIn: 'fade-in',
} as const
export type CardAnimations =
  (typeof CardAnimations)[keyof typeof CardAnimations]

export const CardsGradient = {
  Default: COLOR.ACCENT_PRIMARY_GRADIENT,
  CategoryCard: COLOR.CATEGORY_CARD_ACCENT_PRIMARY_GRADIENT,
}

export const CardDirection = {
  Horizontal: 'row',
  Vertical: 'column',
} as const
export type CardDirection = (typeof CardDirection)[keyof typeof CardDirection]

export const CoversList = {
  Cover1: 'Cover1',
  Cover2: 'Cover2',
  Cover3: 'Cover3',
  Cover4: 'Cover4',
  Cover5: 'Cover5',
  Cover6: 'Cover6',
  Cover7: 'Cover7',
  Cover8: 'Cover8',
  Cover9: 'Cover9',
} as const
export type CoversList = (typeof CoversList)[keyof typeof CoversList]

export const CoversMap = {
  Cover1: BundleCovers.BundleCover1,
  Cover2: BundleCovers.BundleCover2,
  Cover3: BundleCovers.BundleCover3,
  Cover4: BundleCovers.BundleCover4,
  Cover5: BundleCovers.BundleCover5,
  Cover6: BundleCovers.BundleCover6,
  Cover7: BundleCovers.BundleCover7,
  Cover8: BundleCovers.BundleCover8,
  Cover9: BundleCovers.BundleCover9,
}

export const CardPosterSize = {
  Default: 100,
  TvPosterDefault: 66.8,
  TvPosterRounded: 54.1,
  TvPosterWidthDefault: 36.8,
  TvPosterHeightDefault: 62.8,
  TvPosterEPGContainerWidth: 33.9,
  TvPosterEPGContainerHeight: 66.7,
  TvPosterEPGWidth: 74.2,
  TvSimplePosterContainerWidth: 37.8,
  TvSimplePosterContainerHeight: 67.3,
  TvSimplePosterWidth: 70.7,
} as const
export type CardPosterSize =
  (typeof CardPosterSize)[keyof typeof CardPosterSize]

export type CardContentTypeT =
  | 'VODS_ADAPTIVE'
  | 'CHANNELS_ADAPTIVE'
  | 'EPISODES_ADAPTIVE'
  | 'VODS_ADAPTIVE_TOP_CONTENT'
  | 'CHANNELS_ADAPTIVE_TOP_CONTENT'
  | 'EVENTS_ADAPTIVE'

export const CardContentType: Record<CardContentTypeT, CardContentTypeT> = {
  VODS_ADAPTIVE: 'VODS_ADAPTIVE',
  CHANNELS_ADAPTIVE: 'CHANNELS_ADAPTIVE',
  EPISODES_ADAPTIVE: 'EPISODES_ADAPTIVE',
  VODS_ADAPTIVE_TOP_CONTENT: 'VODS_ADAPTIVE_TOP_CONTENT',
  CHANNELS_ADAPTIVE_TOP_CONTENT: 'CHANNELS_ADAPTIVE_TOP_CONTENT',
  EVENTS_ADAPTIVE: 'EVENTS_ADAPTIVE',
}

export type CardSizeT = 'S' | 'M' | 'L'

export const CardSize: Record<CardSizeT, CardSizeT> = {
  S: 'S',
  M: 'M',
  L: 'L',
}
export type CardTypeT =
  | 'HORIZONTAL'
  | 'VERTICAL'
  | 'HORIZONTAL_VOD_TOP_CONTENT'
  | 'VERTICAL_VOD_TOP_CONTENT'
  | 'HORIZONTAL_CHANNEL_TOP_CONTENT'
  | 'VERTICAL_EVENT_TOP_CONTENT'
  | 'HORIZONTAL_EVENT_TOP_CONTENT'
  | 'HORIZONTAL_SEARCH'

export const CardType: Record<CardTypeT, CardTypeT> = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  HORIZONTAL_VOD_TOP_CONTENT: 'HORIZONTAL_VOD_TOP_CONTENT',
  VERTICAL_VOD_TOP_CONTENT: 'VERTICAL_VOD_TOP_CONTENT',
  HORIZONTAL_CHANNEL_TOP_CONTENT: 'HORIZONTAL_CHANNEL_TOP_CONTENT',
  VERTICAL_EVENT_TOP_CONTENT: 'VERTICAL_EVENT_TOP_CONTENT',
  HORIZONTAL_EVENT_TOP_CONTENT: 'HORIZONTAL_EVENT_TOP_CONTENT',
  HORIZONTAL_SEARCH: 'HORIZONTAL_SEARCH',
}
